// ======================================================================
// File Name       : ContentVideoDetail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { Col, Form, Image, Table } from 'react-bootstrap';
import { VIDEO_STATUS } from '../../constants/ContentConstant';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import ItemVideoThumbnail from '../../images/item_video_thumbnail.svg';
import { convertNumberToTimeFormat, getItemBoxName } from '../../utils/index';

const ContentVideoDetail = ({ video, onOpenVideo, isConfirmDialog, isRegisterMode, uploadFile }) => {
  const videoPlayTime = convertNumberToTimeFormat(video.videoPlayTime);
  let videoChapterList = null;
  if (video.videoChapterList && video.videoChapterList.length) {
    videoChapterList = video.videoChapterList.map((videoChapter, index) => (
      <tr key={index}>
        <td>{videoChapter.videoChapterName}</td>
        <td>{convertNumberToTimeFormat(videoChapter.videoChapterPos)}</td>
      </tr>
    ));
  }

  const srcImg =
    video && video.videoThumbnailInfo && video.videoThumbnailInfo.videoThumbnailUrl
      ? video.videoThumbnailInfo.videoThumbnailUrl
      : ItemVideoThumbnail;
  return (
    <div id="contentVideoDetail">
      <Col sm={12}>
        <Form className='form-horizontal'>
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">
              コンテンツ識別ID
            </Col>
            <Col sm={9} className="padding-top-bottom-10">
              {video.contentSecernId}
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">
              コンテンツ名
            </Col>
            <Col sm={9} className="padding-top-bottom-10">
              {video.contentName}
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">
              再生時間
            </Col>
            <Col sm={9} className="padding-top-bottom-10">
              {videoPlayTime}
            </Col>
          </Form.Group>
          {/* START #6406 */}
          {!isConfirmDialog && (
            <Form.Group className="form-info">
              <Col sm={3} className="form-label">
                変換ステータス
              </Col>
              <Col sm={9} className="padding-top-bottom-10">
                {getItemBoxName(SELECT_BOX_DATA.VIDEO_STATUS, video.videoStatus)}
              </Col>
            </Form.Group>
          )}
          {/* END #6406 */}
          {!isRegisterMode && !uploadFile ? (
            <Form.Group className="form-info label-middle">
              <Col sm={3} className="form-label">
                サムネイル画像
              </Col>
              <Col md={9} className="padding-top-bottom-10">
                {video.videoStatus === VIDEO_STATUS.ONLINE &&
                !isConfirmDialog ? (
                  <a
                    href="#"
                    className="thumbnail"
                    onClick={(e) => {
                      e.preventDefault();
                      onOpenVideo();
                    }}
                  >
                    <Image alt="NoImage" src={srcImg} />
                  </a>
                ) : (
                  <Image className="thumbnail" alt="NoImage" src={srcImg} />
                )}
              </Col>
            </Form.Group>
          ) : null}
        </Form>
      </Col>
      <Col sm={12} className="padding-left-right-clear padding-bottom-10">
        <p className="margin-top-10">チャプター</p>
      </Col>
      <Table striped hover>
        <thead>
          <tr>
            <th>チャプター名</th>
            <th>再生時間</th>
          </tr>
        </thead>
        <tbody>{videoChapterList}</tbody>
      </Table>
    </div>
  );
};

export default ContentVideoDetail;
